import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useHideModal } from '../../actions/modal';
import { EFB_WHATS_NEW_STATE, setLocalStorage } from '../../hocs/useLocalStorage';
import version from '../../service/whatsNew';

export const useWhatsNewModalContent = () => {
    const hideModal = useHideModal();
    const { t: translate } = useTranslation();

    const handleSetAccept = useCallback(() => {
        setLocalStorage(EFB_WHATS_NEW_STATE, { [`${version.NUMBER}`]: true }, {});
        hideModal();
    }, [hideModal]);

    const actionList = useMemo(
        () => [
            {
                label: translate('close'),
                variant: 'text',
                onClick: hideModal,
            },
        ],
        [hideModal]
    );

    return { actionList, handleSetAccept };
};
